import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { getCarModel ,getCarBrand , updateCarModel , DeleteCarModel} from '../../../actions';
import Swal from 'sweetalert2';

const CarModelNew = () => {
    const carModelList = []
    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCarModel())
		dispatch(getCarBrand())
        localStorage.removeItem('editCarModel-data')
    },[])

    const carModelLists = useSelector(state => state.home.carModelList)?.response
	const carBrand = useSelector(state => state.home.CarBrandList)

    const editDataHandler = (id) => {
        console.log(id);
        const filteredData = carModelLists?.filter(model => model?.carModelId === id)
        localStorage.setItem('editCarModel-data', JSON.stringify(filteredData?.[0]))
        console.log("filteredData", filteredData);
    }

	const handleStatusChange = (Id , status ) =>{
		var data ={
			carModelId: Id,
			status:!status
		}
		dispatch(updateCarModel(data))
	}

	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarModel(ID))
		// console.log("ID", ID);
		}
	}

    const columns = [
		{
			name: 'name',
			label: 'Car Model Name',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'nameAr',
			label: 'Car Model Name Ar',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'brandId',
			label: 'Car Brand Name',
			options: {
				filter: false,
				sort: true,
				customBodyRender: (brandId) => {
					var fill = carBrand?.response?.filter(item=>item?.brandId===brandId)
					// console.log("FLL",fill[0]?.name );
					return <span>{fill? fill[0]?.name : ""}</span>
				},
			},
		},
		{
			name: 'priority',
			label: 'Priority ',
			options: {
				filter: false,
				customBodyRender: (priority) => {
					return <span>{priority}</span>;
				},
			},
		},

		{
			name: 'status',
			label: 'Status',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (status, tableMeta) => {	
					const rowData = tableMeta.rowData;
					const Id = rowData[tableMeta.rowData.length - 1]; // if it's the last column

					return (
						<Toggle
							id={'status_' + Id}
							defaultChecked={status}
							value={status}
							onChange={()=>handleStatusChange(Id, status)}
						/>
					);
				},
			},
		},
		{
			name: 'carModelId',
			label: 'Action',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (carModelId) => {
					return (
						<div>
							<Link to={`/CarDetail/CarModel/${carModelId}?`} onClick={() => editDataHandler(carModelId)} >
                                <FaEdit style={{fontSize: '1.4rem'}} />
                            </Link>
							<span className='delBTN' onClick={()=>HandleDelete(carModelId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
						</div>
					);
				},
			},
		},

	];
 
    const options = {
		filter: false,
		viewColumns: false,
		print: false,
		download: false,
		selectableRows: 'none',
		textLabels: {
			body: {
				// noMatch: this.state.isSaving
				// 	? 'Loading data..!'
				// 	: 'Sorry, No Users Found',
				toolTip: 'Sort',
				columnHeaderTooltip: column => `Sort for ${column.label}`,
			},
		},
	};

    console.log("carModelLists", carModelLists);
  return (
    <div className='pcoded-inner-content'>
        <div className='main-body'>
            <div className='page-wrapper'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <Link
                                    to={`/CarDetail/CarModel/Add`}
                                    className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
                                    data-modal='modal-13'>
                                    {' '}
                                    <i className='icofont icofont-plus m-r-5'></i>
                                    Add Car Model
                                </Link>
                            </div>

                            <div className='card-block'>
                                <div className='dt-responsive table-responsive'>
                                    {carModelList !== undefined ? (
                                        <MUIDataTable
                                            title={`Car Model`}
                                            className='table-responsive'
                                            data={carModelLists}
                                            columns={columns}
                                            options={options}
                                        />
                                    ) : (
                                        <h4>Loading...</h4>
                                    )}
                                    {/* </MuiThemeProvider> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        
  )
}

export default CarModelNew